import { SqliteRevisionedRepository } from "./sqlite-revisioned-repository.js";
export class SqliteRevisionedSettingsRepository extends SqliteRevisionedRepository {
    constructor(database, options = {}) {
        super(database, { ...options, domain: "settings" });
    }
}
//# sourceMappingURL=settings-repository.js.map